// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audio-controls-section {
  z-index: 1061;
  position: relative;
  background-color: white;
  margin: 0 -20px;
  padding: 20px 20px 0px 20px;
}

.composition-info-container {
  text-align: left;
  color: #243547;
}

.composition-info-container>* {
  margin-bottom: 0px;
  color: #243547;
}

.composition-info-wrapper {
  display: flex;
}


.composition-title-wrapper {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.composition-title {
  height: 19px;
  margin: 0 0 8px;
  font-style: normal;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #243547;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.composition-subtitle {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 0px;
  color: #475b70;
  font-size: 14px;
}

.composer-image {
  max-height: 66.5px;
  border-left: 1px solid black;
  margin-left: 15px;
  padding-left: 15px;
}

.composer-image-unavailable {
  max-height: 66.5px;
  border-left: 1px solid black;
  margin-left: 15px;
  padding-left: 15px;
  width: 135px;
  overflow-y: hidden;
  display: flex;
  object-fit: cover;
}

/* .info-icon {
  margin-bottom: 10px;
  margin-left: 10px;
} */

.info-btn {
  padding: 0px;
  margin-bottom: 9px;
  margin-left: 5px;
}

.close-btn-container {
  text-align: right;
}

@media (max-width: 600px) {
  .composer-image-unavailable {
    width: 100%;
  }

  .composition-info-title-div {
    max-width: 75%;
  }

  .composition-info-img-div {
    max-width: 25%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/AudioControlsSection/AudioControlsSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".audio-controls-section {\n  z-index: 1061;\n  position: relative;\n  background-color: white;\n  margin: 0 -20px;\n  padding: 20px 20px 0px 20px;\n}\n\n.composition-info-container {\n  text-align: left;\n  color: #243547;\n}\n\n.composition-info-container>* {\n  margin-bottom: 0px;\n  color: #243547;\n}\n\n.composition-info-wrapper {\n  display: flex;\n}\n\n\n.composition-title-wrapper {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n}\n\n.composition-title {\n  height: 19px;\n  margin: 0 0 8px;\n  font-style: normal;\n  margin-bottom: 10px;\n  font-size: 16px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.25;\n  letter-spacing: normal;\n  text-align: left;\n  color: #243547;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.composition-subtitle {\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 0px;\n  color: #475b70;\n  font-size: 14px;\n}\n\n.composer-image {\n  max-height: 66.5px;\n  border-left: 1px solid black;\n  margin-left: 15px;\n  padding-left: 15px;\n}\n\n.composer-image-unavailable {\n  max-height: 66.5px;\n  border-left: 1px solid black;\n  margin-left: 15px;\n  padding-left: 15px;\n  width: 135px;\n  overflow-y: hidden;\n  display: flex;\n  object-fit: cover;\n}\n\n/* .info-icon {\n  margin-bottom: 10px;\n  margin-left: 10px;\n} */\n\n.info-btn {\n  padding: 0px;\n  margin-bottom: 9px;\n  margin-left: 5px;\n}\n\n.close-btn-container {\n  text-align: right;\n}\n\n@media (max-width: 600px) {\n  .composer-image-unavailable {\n    width: 100%;\n  }\n\n  .composition-info-title-div {\n    max-width: 75%;\n  }\n\n  .composition-info-img-div {\n    max-width: 25%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
